module.exports = __webpack_public_path__ + "img/aeroland-ebook-image-03.8e50f354.jpg";